
import {
    ref,
    defineComponent,
    computed,
    watch,
    reactive,
    toRaw,
    onMounted,
} from 'vue'
import { useStore } from 'vuex'
import { mod } from '../request'
import { getList } from '../../version/request'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { getList as packageList } from '../../packages/request'
import multiply from 'library/functions/multiply'
import divide from 'library/functions/divide'
import deepClone from 'library/functions/deepClone'
import _ from 'lodash'
export default defineComponent({
    setup(props, { emit }) {
        const store = useStore()
        const formRef = ref()
        const packageOptions = ref([])
        const signatureInputValue = ref('')
        const detail = computed(() => store.state.business.detail)
        interface Form {
            name: string
            expireDate: any
            type: number
            isOpenConversation: null | number
            versionId: number
            openNetSchool: Number
            isOpenNetSchool: Boolean
            numCount: number | null
            convCount: number | null
            money: number | null
            follower: string
            pkgIds: any
            smsPrice: number | null
            signature: any
        }
        const form = reactive<Form>({
            name: '',
            expireDate: null,
            type: 2,
            isOpenConversation: null,
            versionId: 1,
            openNetSchool: 0,
            signature: [],
            isOpenNetSchool: false,
            money: null,
            numCount: null,
            convCount: null,
            follower: '',
            smsPrice: null,
            pkgIds: [],
        })
        const init = () => {
            if (detail.value) {
                Object.assign(form, {
                    name: detail.value.name,
                    status: detail.value.status,
                    versionId: detail.value.versionId,
                    type: detail.value.type,
                    isOpenConversation: detail.value.isOpenConversation,
                    follower: detail.value.follower,
                    convCount: detail.value.convCount,
                    money: detail.value.money,
                    numCount: detail.value.numCount,
                    smsPrice: detail.value.smsPrice
                        ? divide(detail.value.smsPrice, 100)
                        : null,
                    signature: detail.value.signature,
                    pkgIds: detail.value.pkgIds.split(',').map((item) => {
                        return +item
                    }),
                    expireDate: detail.value.expireDate
                        ? moment(detail.value.expireDate)
                        : '',
                    openNetSchool: detail.value.openNetSchool,
                })
                form.isOpenNetSchool = form.openNetSchool === 1
            }
        }
        const rules = {
            name: [
                {
                    required: true,
                    message: '请输入商户名称',
                },
            ],
            pkgIds: [
                {
                    required: true,
                    message: '请选择功能包',
                },
            ],
            type: [
                {
                    required: true,
                    message: '请选择类型',
                    type: 'number',
                },
            ],
            isOpenConversation: [
                {
                    required: true,
                    message: '请选择是否开通了会话存档',
                    type: 'number',
                },
            ],
            expireDate: [
                // {
                //     required: true,
                //     message: '过期时间必填',
                //     type: 'date'
                // }
            ],
        }
        const loading = ref<boolean>(false)
        const afterClose = () => {
            store.commit('toggleBusinessAddState', false)
            store.commit('setBusinessDetail', null)
        }
        const versionList = ref([])
        const getVersions = async () => {
            try {
                let params = {}
                const { data } = await getList(params)
                versionList.value = data((item: any) => {
                    return {
                        ...item,
                        value: item.id,
                        label: item.name,
                    }
                })
            } catch (error) {
                console.log(error)
            }
        }

        const allPkgList = ref([])
        let selectedAppIds = ref<number[]>([])
        const fetchPackageList = () => {
            packageList({}).then((res) => {
                let pkgIds = detail.value.pkgIds.split(',').map((item) => {
                    return +item
                })
                allPkgList.value = deepClone(res.data)
                packageOptions.value = res.data.filter(
                    (item: any) => !item.isAppPkg
                )
                let appList = res.data.filter((item: any) => item.isAppPkg)
                let appIds = appList.map((app) => {
                    return app.id
                })

                pkgIds.forEach((id: number) => {
                    if (appIds.indexOf(id) > -1) {
                        selectedAppIds.value.push(id)
                    }
                })
                selectedAppIds.value = _.uniq(selectedAppIds.value)
            })
        }
        function handleSignatureInputConfirm() {
            let signature = signatureInputValue.value
            form.signature.push({
                name: signature,
            })
            signatureInputValue.value = ''
        }
        function handleCloseSignature(index) {
            form.signature.splice(index, 1)
        }
        const handleOpenNetSchool = () => {
            form.openNetSchool = form.isOpenNetSchool ? 1 : 0
        }
        const onSubmit = () => {
            formRef.value.validate().then(async () => {
                let formValue = toRaw(form)
                if (formValue.type === 2) {
                    if (!formValue.numCount) {
                        message.warn('请输入端口数量')
                        return
                    }
                    if (!formValue.money) {
                        message.warn('请输入收款金额')
                        return
                    }
                    if (!formValue.follower) {
                        message.warn('请输入跟进人')
                        return
                    }
                }
                if (formValue.isOpenConversation) {
                    if (!formValue.convCount) {
                        message.warn('请输入会话存档数')
                        return
                    }
                }
                let params: any = {
                    id: detail.value.id,
                    ...form,
                    pkgIds: form.pkgIds.concat(selectedAppIds.value),
                    expireDate: +formValue.expireDate,
                    smsPrice: multiply(formValue.smsPrice, 100),
                }
                if (formValue.money) {
                    Object.assign(params, {
                        money: +formValue.money,
                    })
                }
                delete params.isOpenNetSchool
                loading.value = true
                try {
                    await mod(params)
                    loading.value = false
                    afterClose()
                    emit('success')
                    message.success('保存成功')
                } catch (e) {
                    loading.value = false
                }
            })
        }
        watch(detail, () => {
            init()
        })
        onMounted(() => {
            init()
            getVersions()
            fetchPackageList()
        })

        return {
            form,
            store,
            loading,
            rules,
            onSubmit,
            afterClose,
            detail,
            signatureInputValue,
            formRef,
            versionList,
            packageOptions,
            handleOpenNetSchool,
            handleSignatureInputConfirm,
            handleCloseSignature,
        }
    },
})
